import {
  MailingDoubleOptInSettingsInterface,
  MailingDoubleOptInUpdateInterface,
} from 'modules/profile/mailing-settings/types/mailing-settings-double-optin-interface'
import httpClient from 'shared/utils/http-client'

export const MAILING_DOUBLE_OPT_IN_SETTINGS_API =
  '/api/dashboard/customer/settings/mailing/double-opt-in'

export const updateMailingDoubleOptInSettings = (data: MailingDoubleOptInUpdateInterface) =>
  httpClient.put<MailingDoubleOptInSettingsInterface>(MAILING_DOUBLE_OPT_IN_SETTINGS_API, data)
